(function () {
  const SECTION_ID = 'private-sale-product-price';
  const cache = new Map();
  const inflight = new Map();

  function productHandleFromHref(href) {
    try {
      const path = new URL(href, window.shopUrl || window.location.origin).pathname;
      const match = path.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : null;
    } catch {
      return null;
    }
  }

  function findPricingRoot(card) {
    return (
      card.querySelector('.dfd-card-pricing') ||
      card.querySelector('.df-card__pricing') ||
      card.querySelector('[class*="dfd-card-price"]')?.closest('div')
    );
  }

  function fetchPriceHtml(handle) {
    if (cache.has(handle)) {
      return Promise.resolve(cache.get(handle));
    }
    if (inflight.has(handle)) {
      return inflight.get(handle);
    }
    const origin = window.shopUrl || window.location.origin;
    const url = `${origin}/products/${encodeURIComponent(handle)}?section_id=${SECTION_ID}`;
    const promise = fetch(url, { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((sections) => {
        const html = sections?.[SECTION_ID] || '';
        cache.set(handle, html);
        inflight.delete(handle);
        return html;
      })
      .catch(() => {
        inflight.delete(handle);
        return '';
      });
    inflight.set(handle, promise);
    return promise;
  }

  function shouldPatchHtml(html) {
    return /price--private-sale|price__private/.test(html);
  }

  function shouldSkipPrivateSalePatch() {
    const phase = document.documentElement.getAttribute('data-private-sale-phase') || '';
    const isApp =
      /rktwebview/i.test(navigator.userAgent || '') ||
      document.documentElement.classList.contains('rkt-app');
    return phase === 'web' && isApp;
  }

  function patchDoofinderPrices() {
    if (shouldSkipPrivateSalePatch()) {
      return;
    }
    const links = document.querySelectorAll(
      'a[href*="/products/"][data-role="result-link"], a[href*="/products/"].dfd-card-link, .dfd-card a[href*="/products/"], .df-card a[href*="/products/"]',
    );

    links.forEach((link) => {
      const card =
        link.closest('[data-role="result"]') ||
        link.closest('.dfd-card') ||
        link.closest('.df-card') ||
        link.closest('article') ||
        link.parentElement;
      if (!card) {
        return;
      }

      const pricing = findPricingRoot(card);
      if (!pricing || pricing.dataset.privateSalePatched === '1' || pricing.dataset.privateSalePending === '1') {
        return;
      }

      const handle = productHandleFromHref(link.href);
      if (!handle) {
        return;
      }

      pricing.dataset.privateSalePending = '1';
      fetchPriceHtml(handle).then((html) => {
        pricing.dataset.privateSalePending = '0';
        if (!shouldPatchHtml(html)) {
          return;
        }
        pricing.innerHTML = html.trim();
        pricing.dataset.privateSalePatched = '1';
        pricing.classList.add('private-sale-doofinder-price');
      });
    });
  }

  let timer;
  function schedulePatch() {
    clearTimeout(timer);
    timer = setTimeout(patchDoofinderPrices, 80);
  }

  document.addEventListener('doofinder.layer.update', schedulePatch);
  document.addEventListener('doofinder.layer.load', schedulePatch);
  document.addEventListener('doofinder.carousel.load', schedulePatch);
  schedulePatch();
})();
